import { FC } from 'react';

export const BuilderIoImageInputs = [
  {
    type: 'file',
    name: 'mobileImage',
    helperText: 'Choose image which will be applied for mobile devices',
    required: true,
  },
  {
    type: 'file',
    name: 'desktopImage',
    helperText: 'Choose image which will be applied for desktop devices',
    required: true,
  },
  {
    type: 'altText',
    name: 'Alt text',
    helperText: 'Alt text which will be displayed if images was not available',
  },
];

export const BuilderIoImage: FC<{
  desktopImage: string;
  mobileImage: string;
  altText: string;
}> = ({ altText, mobileImage, desktopImage }) => {
  const breakpoint = 768;

  return (
    <picture>
      <source media={`(min-width: ${breakpoint}px)`} srcSet={desktopImage} />
      <source media={`(max-width: ${breakpoint - 1}px)`} srcSet={mobileImage} />
      <img src={mobileImage} alt={altText} style={{ maxWidth: '100%', height: 'auto' }} />
    </picture>
  );
};
